import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@sdbn/appclient';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { SharedModule } from 'src/app/shared/shared.module';

import { ApplicationClientCommonModule } from '@sdbn/appclient';

import { RFIDCardComponent } from './component/rfid-card.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    CommonUIModule,
    CommonTranslationModule,
    ApplicationClientCommonModule
  ],
  declarations: [
    RFIDCardComponent
  ]
})
export class RFIDCardModule { }

